module.exports = __webpack_public_path__ + "static/media/suspension_red.9eb7f583.png";